import React from 'react';

import { useTranslation } from '@modernloop/i18n';

import BaseGreenhouseAshbyPermissionDialog from './BaseGreenhouseAshbyPermissionDialog';

type Props = {
  jobId: string;
  onHasPermission: () => void;
  onClose: () => void;
};

const AshbyCreateCandidatePermissionDialog = ({ jobId, onHasPermission, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <BaseGreenhouseAshbyPermissionDialog
      jobId={jobId}
      onHasPermission={onHasPermission}
      onClose={onClose}
      notAnAdminHelpText={t('hiring-dashboard-jobs:jobs.sourcingLinks.permissions.ashbyNotAdminHelp')}
      atsPermissionGrantUrl="https://app.ashbyhq.com/admin/api/keys"
      permissionsListText="Write"
    />
  );
};

export default AshbyCreateCandidatePermissionDialog;
